/** @returns {boolean} */
export function isRemindersEnabledForUser(userData) {
  return Boolean(userData?.permissions?.remindersEnabled);
}

/** Admin roles that can assign Reminders in user management and Home Designer. */
export const REMINDERS_ADMIN_ROLES = new Set(['superadmin', 'admin', 'tenant_admin']);
